import styled from "styled-components";

import { TextField } from "@eriksdigital/atomic-ui/components";

export const TextFieldWrapper = styled(TextField)`
  input {
    height: 38px;
  }
`;
